export const MAP_CONFIG = {
  center: [5.95, 52.73],
  zoom: 12,
  pitch: 45,
  minZoom: 10,
  maxZoom: 18,
  maxBounds: [
    [5.70, 52.60],
    [6.20, 52.85],
  ],
};

export const DEMO_BBOX = {
  west: 5.88,
  south: 52.69,
  east: 6.05,
  north: 52.78,
};

// WFS uses lat/lon order for EPSG:4326
export const DEMO_BBOX_WFS = `${DEMO_BBOX.south},${DEMO_BBOX.west},${DEMO_BBOX.north},${DEMO_BBOX.east},EPSG:4326`;

// OGC API Features uses lon/lat order
export const DEMO_BBOX_OGC = `${DEMO_BBOX.west},${DEMO_BBOX.south},${DEMO_BBOX.east},${DEMO_BBOX.north}`;

export const BASEMAP_URL =
  'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/standaard/EPSG:3857/{z}/{x}/{y}.png';

export const BASEMAP_ATTRIBUTION =
  'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a> | ' +
  'BRP &copy; <a href="https://www.rvo.nl">RVO</a> | ' +
  'BGT &copy; <a href="https://www.kadaster.nl">Kadaster</a>';
